import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { profileData, skills, projects, education } from '../data/index.jsx';
import Navbar from './Navbar';
import Hero from './Hero';
import CodeAnimation from './CodeAnimation';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Education from './Education';
import Contact from './Contact';
import Footer from './Footer';
import CustomCursor from './CustomCursor';

gsap.registerPlugin(ScrollTrigger);

const App = () => {
  useEffect(() => {
    // GSAP Scroll Animations
    gsap.utils.toArray('.section-title').forEach((title) => {
      gsap.fromTo(title,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: title,
            start: 'top 80%',
            end: 'bottom 20%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    // Animate cards on scroll
    gsap.utils.toArray('.card').forEach((card, index) => {
      gsap.fromTo(card,
        { opacity: 0, y: 50, scale: 0.9 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          delay: index * 0.1,
          scrollTrigger: {
            trigger: card,
            start: 'top 85%',
            end: 'bottom 15%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    // Parallax effect for background elements
    gsap.utils.toArray('.parallax-bg').forEach((bg) => {
      gsap.to(bg, {
        yPercent: -50,
        ease: 'none',
        scrollTrigger: {
          trigger: bg,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-gray-50 cursor-none">
      <CustomCursor />
      <Navbar />
      <Hero profileData={profileData} />
      <CodeAnimation />
      <About />
      <Skills skills={skills} />
      <Projects projects={projects} />
      <Education education={education} />
      <Contact email={profileData.email} />
      <Footer />
    </div>
  );
};

export default App;